var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect, useCallback } from 'react';
import { Select } from 'antd';
import { _ } from 'oss-toolkits';
// const isBrowser = typeof window !== 'undefined';
// const { _ } = isBrowser ? require('oss-web-toolkits') : { _: undefined };
const SelectSearch = (_a) => {
    var { request, initialRequest = true, wait = 500, options = null, pageSize: defaultPageSize = 20, disableScroll = false } = _a, restProps = __rest(_a, ["request", "initialRequest", "wait", "options", "pageSize", "disableScroll"]);
    const [currentOptions, setCurrentOptions] = useState([]);
    const [pageSize] = useState(defaultPageSize);
    const [pageNum, setPageNum] = useState(1);
    const [keywords, setKeywords] = useState('');
    const handleSearch = (value) => {
        getOpionsData(value);
    };
    const getData = useCallback((value, num) => {
        request(value, pageSize, num).then((res) => {
            const data = num === 1 ? res : num > pageNum ? currentOptions.concat(res) : currentOptions;
            if (res && res.length > 0) {
                setPageNum(num);
            }
            else {
                setPageNum(num - 1);
            }
            return setCurrentOptions(data);
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentOptions]);
    const getOpionsData = _.debounce((value) => {
        // setPageNum(1);
        setKeywords(value);
        getData(value, 1);
    }, wait);
    const onPopupScroll = (event) => {
        if (disableScroll) {
            return;
        }
        const clientHeight = event.target.clientHeight, scrollHeight = event.target.scrollHeight, scrollTop = event.target.scrollTop, isBottom = clientHeight + scrollTop >= scrollHeight;
        if (isBottom) {
            getData(keywords, pageNum + 1);
        }
    };
    useEffect(() => {
        if (initialRequest)
            getOpionsData('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<Select {...restProps} showSearch defaultActiveFirstOption={false} filterOption={false} onSearch={handleSearch} notFoundContent={null} onPopupScroll={onPopupScroll} options={options || currentOptions}/>);
};
export default SelectSearch;
